import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DashboardIcon, PortalIcon, ReportIcon } from "../icon/icon";
import { notAllowFooter, routes } from "../helpers/constants";
import { checkIsEnable } from "../helpers/commonFunction";
import { useSelector } from "react-redux";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userReducer);

  const handleChangePage = (tab) => {
    navigate(tab.to);
  };

  const getFooterLinks = () => {
    if (user?.user_role === "DM") {
      return [
        {
          to: routes.dmPortal,
          icon: PortalIcon,
          label: "Portal",
          isActive: checkIsEnable(routes.dmPortal),
          disabled: false,
          activePages: [
            routes.dmPortal,
            routes.dmRestaurantReport,
            routes.dmFTSReport,
            routes.dmAuditorReport,
            routes.dmLabReport,
          ],
        },
      ];
    } else if (user?.user_role === "ADMIN") {
      return [
        {
          to: routes.adminPortal,
          icon: PortalIcon,
          label: "Portal",
          isActive: checkIsEnable(routes.adminPortal),
          disabled: false,
          activePages: [
            routes.adminPortal,
            routes.adminRestaurantReport,
            routes.adminFTSReport,
            routes.adminAuditorReport,
            routes.adminLabReport,
          ],
        },
      ];
    } else {
      return [];
    }
  };

  return (
    <>
      {!notAllowFooter.includes(location?.pathname) && (
        <footer className="tc-footer">
          <div
            className={`tc-footer-content ${
              getFooterLinks()?.length < 2
                ? "justify-content-center"
                : getFooterLinks()?.length < 4
                ? "justify-content-around"
                : ""
            }`}
          >
            {/* {getFooterLinks().map((tab, i) => {
              if (tab.isActive) {
                return (
                  <span
                    key={i}
                    role="button"
                    onClick={() => handleChangePage(tab)}
                    className={`tc-footer-tab ${
                      location.pathname === tab.to
                        ? "active"
                        : tab.to === routes.reports &&
                          tab.activePages.includes(location.pathname)
                        ? "active"
                        : tab.to === routes.dmPortal &&
                          tab.activePages.includes(location.pathname)
                        ? "active"
                        : tab.to === routes.adminPortal &&
                          tab.activePages.includes(location.pathname)
                        ? "active"
                        : ""
                    } ${tab.disabled && "pe-none"}`}
                  >
                    {tab.icon}
                    {tab.label}
                  </span>
                );
              } else {
                return null;
              }
            })} */}
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
